import React, { forwardRef } from "react";
import AmpToolTip from "../AmpToolTip/AmpToolTip";
import styles from "./AmpCheckBox.module.css";

interface AmpCheckBoxProps {
    handleCheck: React.ChangeEventHandler;
    id: string;
    label: string;
    hasToolTip: boolean | undefined;
    toolTip: string;
    isSlider?: boolean;
    defaultValue?: string;
    defaultChecked?: boolean;
    disabled?: boolean;
    blueStyle?: boolean;
    tooltipAlign?: string;
}

const AmpCheckBox = forwardRef(function AmpCheckBox(props: AmpCheckBoxProps, ref): JSX.Element {

    return (<>
        {props.isSlider ? (
            <div className={styles.sliderparent}>
                <label htmlFor={props.id}>{props.label}</label>
                <label className={styles.switch} htmlFor={props.id}>
                    <input ref={ref} id={props.id} type="checkbox" onChange={(e) => props.handleCheck(e)} defaultValue={props.defaultValue} defaultChecked={props.defaultChecked} disabled={props.disabled}/>
                    <div className={`${styles.round} ${styles.slider}`}></div>
                </label>
                {props.hasToolTip ?
                        <AmpToolTip id={`checkbox-id-${props.id}`} content={props.toolTip} textDirection={props.tooltipAlign}/> :
                        <></>
                }
            </div>
        ) :

            (<div>
                <span className={`${props.blueStyle && styles.blue}`}>
                    <label htmlFor={props.id}>{props.label}</label>
                    <input ref={ref} id={props.id} type="checkbox" onChange={(e) => props.handleCheck(e)} defaultValue={props.defaultValue} defaultChecked={props.defaultChecked} disabled={props.disabled}/>
                    {props.hasToolTip ?
                        <AmpToolTip id={`checkbox-id-${props.id}`} content={props.toolTip} textDirection={props.tooltipAlign}/> :
                        <></>
                    }
                </span>
            </div>)}
    </>)
})

export default AmpCheckBox;

